import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nextProvider } from "react-i18next";
import { widgetI18n } from "./lib/i18n/widgetI18n";

const queryClient = new QueryClient();

export function WidgetProviders({ children }: { children: React.ReactNode }) {
  return (
    <I18nextProvider i18n={widgetI18n}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </I18nextProvider>
  );
}

export { queryClient };
